import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProductLevelFromApiNameString } from './FeaturesUtils';
const TableCell = styled.td.withConfig({
  displayName: "FeaturesTableCell__TableCell",
  componentId: "sc-6iec3q-0"
})(["height:40px;padding:10px 20px;width:18.75%;min-width:175px;text-align:center !important;p{margin:0;}line-height:14px;"]);
const StyledTooltipSection = styled.div.withConfig({
  displayName: "FeaturesTableCell__StyledTooltipSection",
  componentId: "sc-6iec3q-1"
})(["margin-bottom:8px;&:last-child{margin-bottom:0;}"]);

const FeaturesTableCell = ({
  feature,
  showTooltip = true,
  apiName,
  onlyShowCurrent = false
}) => {
  const removeBreaks = content => {
    const sections = content.split(/<br\/>|<br \/>/);
    const formattedSections = [];
    sections.forEach((section, index) => {
      formattedSections.push( /*#__PURE__*/_jsx("p", {
        children: section
      }, index));
    });
    return formattedSections;
  };

  const getProductFeatureLongLimit = () => {
    const sections = [];

    if (!Object.keys(feature.longLimits).length) {
      return null;
    }

    const shouldShowTooltip = !!Object.keys(feature.longLimits).find(innerApiName => {
      return !!feature.longLimits[innerApiName];
    });

    if (shouldShowTooltip) {
      if (onlyShowCurrent) {
        if (feature.longLimits[apiName]) {
          const level = getProductLevelFromApiNameString(apiName);
          sections.push({
            key: `${apiName}-${feature.featureId}`,
            value: feature.longLimits[apiName],
            label: `pricing-pages.tooltips.labels.${level}`
          });
        }
      } else {
        // TODO: Add sorting
        Object.keys(feature.longLimits).forEach(innerApiName => {
          const level = getProductLevelFromApiNameString(innerApiName);
          sections.push({
            key: `${innerApiName}-${feature.featureId}`,
            value: feature.longLimits[innerApiName],
            label: `pricing-pages.tooltips.labels.${level}`
          });
        });
      }

      const formattedSections = [];

      if (!sections.length) {
        return null;
      }

      sections.forEach(({
        key,
        value,
        label
      }) => {
        if (label) {
          formattedSections.push( /*#__PURE__*/_jsxs(StyledTooltipSection, {
            id: key,
            children: [/*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: label
              })
            }), /*#__PURE__*/_jsx("span", {
              children: value
            })]
          }, key));
        }
      });
      return formattedSections;
    }

    return null;
  };

  const getTableCellContent = () => {
    const hasFeature = feature.shouldUseDefaultLimits[apiName] || feature.shortLimits[apiName];
    if (!hasFeature) return null;
    const longLimitContent = getProductFeatureLongLimit();
    const hasTooltip = showTooltip && longLimitContent;
    const shortLimitContent = feature.shortLimits[apiName] ? /*#__PURE__*/_jsx(Small, {
      style: hasTooltip ? {
        cursor: 'help'
      } : {},
      children: feature.shortLimits[apiName] && /*#__PURE__*/_jsx("div", {
        children: removeBreaks(feature.shortLimits[apiName])
      })
    }) : /*#__PURE__*/_jsx(UIIcon, {
      name: "success",
      size: "small"
    });
    return hasTooltip ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: longLimitContent,
      children: shortLimitContent
    }) : shortLimitContent;
  };

  return /*#__PURE__*/_jsx(TableCell, {
    children: getTableCellContent()
  });
};

export default FeaturesTableCell;